import { UTM_PREFIX } from '../../_constants';

type TRouteParams = Record<string, string>;
type TReturnType = TRouteParams;

export const getParamsCleanedUpFromUtm = (
  params: TRouteParams,
): TReturnType => {
  return Object.entries(params).reduce<Record<string, string>>(
    (acc, [key, value]) => {
      if (!key.includes(UTM_PREFIX)) {
        acc[key] = value;
      }

      return acc;
    },
    {},
  );
};
